import './Spoiler.css';
import React from 'react';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconPlus } from '../../../resources/icons/IconPlus.svg';
import { ReactComponent as IconMinus } from '../../../resources/icons/IconMinus.svg';
import { get } from '../../../utils';
import { ReactComponent as ChevronDown } from '../../../resources/icons/arrowDown.svg';
const Spoiler = props => {
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const isDetSite = props.isDetSite || false;
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary') || "#035E88";
  console.log('Spoiler primaryPageThemeColor', get(sitecoreContext, 'themesOfPage.primary'));
  const variables = {
    '--spoiler-main-color': !isDetSite ? primaryPageThemeColor : "#005F66",
    '--spoiler-minus-color': !isDetSite ? "#6E2B62" : "#40484F"
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables,
    isDetSite: isDetSite,
    className: props.className
  }, /*#__PURE__*/React.createElement("details", {
    onToggle: e => props.onToggle && props.onToggle(e.currentTarget.open),
    className: "spoiler"
  }, /*#__PURE__*/React.createElement("summary", {
    className: "spoiler__title"
  }, props.title, !isDetSite ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconMinus, {
    className: "spoiler__icon spoiler__icon-minus"
  }), /*#__PURE__*/React.createElement(IconPlus, {
    className: "spoiler__icon spoiler__icon-plus"
  })) : /*#__PURE__*/React.createElement(ChevronDown, {
    className: "spoiler__icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "spoiler__description"
  }, props.children)));
};
export default Spoiler;
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    style,
    isDetSite,
    className
  } = _ref;
  const commonStyles = isDetSite ? "czeah23" : "c1akvzoo";
  const rtlStyles = isDetSite ? "rlxo574" : "rayw08l";
  const ltrStyles = isDetSite ? "l1vuvxro" : "l13ll1xf";
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className ? className : ''}`
  }, children);
};